import { useLocation } from "react-router-dom";

export const pathname = ["/FaqGovernmentActRegulations/", "/FaqGovernmentSecurities/", "/FaqPrimaryIssuances/", "/FaqGoldBonds/", "/FaqFrsb/", "/FaqNdsOmSecondaryMarket/", "/FaqRbiRetailDirect/"
]


const UrlParamChecker = () => {


    const location = useLocation();


    if (location.search === "?app=true") return true
    else return false
}
export const UrlParamFaq = () => {


    const location = useLocation();
 
    if (pathname.includes(location.pathname)) return true
    else return false
}

export default UrlParamChecker;
